import { api } from './api'
import { OrganizationType } from '@/types/organization'

export const organizationService = {
  list: async (): Promise<OrganizationType[]> => {
    const response = await api.get('/organizations')
    return response.data
  },

  acceptInvitation: async (token: string): Promise<any> => {
    const payload = {
      user: {
        invitation_token: token,
      }
    }
    const response = await api.put('/invitation', payload)
    return response.data
  },

  declineInvitation: async (token: string): Promise<void> => {
    const payload = {
      user: {
        invitation_token: token,
        decline: true
      }
    }
    await api.put('/invitation', payload)
  },

  create: async (name: string): Promise<any> => {
    const response = await api.post('/organizations', {
      organization: { name }
    })
    return response.data
  },

  updateModel: async (orgId: number, model: string): Promise<OrganizationType> => {
    const response = await api.put(`/organizations/${orgId}`, {
      organization: { model }
    })
    return response.data
  },

  delete: async (orgId: number): Promise<void> => {
    await api.delete(`/organizations/${orgId}`)
  },
}